/*
 * Any javascript associated with the copay form MUST LIVE HERE!!!!!
 */

copay = { // LIVALO COPAY CARD
    init: function initialize() {
        copay.cE(); // <== cache all the elements that have multiple uses
        copay.eL(); // <== bind the event listeners
        copay.wA();
    },
    cE: function cacheElements() {

        copay.emailForm = document.querySelector("form[data-form='copay']");
        copay.emailInput = $("input[type=email]");

        copay.textFormErrors = 0;
        copay.copayTextForm = $('[data-form="text-copay-form"]');
        copay.copaySubmitTextButton = $('[data-action="request-text-card"]');
        copay.copayPhoneNumber = $('input[name="MobilePhone"]');
        copay.copaySubmitMsg = $('.copay-submitting-msg');
        copay.copaySuccessMsg = $('.copay-success-msg');
        copay.copayPhoneError = $('.phone-error');
        copay.customMessage = ''; // Custom message
        copay.phoneIsValid = false; // use this for ajax call to set in callBack so form can be
    },
    errorCount: 0,
    eL: function eventListeners() {

        if ( !Modernizr.placeholder ) {
            copay.emailInput.on("blur", copay.fakePlaceholder);
            copay.emailInput.on("focus", copay.fakePlaceholder);
        }
        copay.emailForm.addEventListener("submit", copay.formSubmitEvent, false);

        // EVENT LISTENER FOR SUBMIT BUTTON ON COPAY PHONE NUMBER FORM
        $(copay.copaySubmitTextButton).on('click', function (e) {
            e.preventDefault();
            if ( !$(copay.copaySubmitTextButton).hasClass('disabled') ) {
                copay.validateCopayTextForm();
            }
        });

        //	EVENT LISTENER FOR HITTING ENTER KEY ON COPAY PHONE NUMBER FORM
        $(copay.copayPhoneNumber).on('keydown', function (e) {
            copay.onlyAllowNumbers(e);
            copay.checkAndAddSlashes(e);
        });
    },
    wA: function webkitAppearanceEvent() {
        /*
         * If browser supports CSS Appearance, then we use Modernizr to add 'appearance' as a class to the HTML element
         */
        if ( Modernizr.testProp('webkitAppearance') || Modernizr.testProp('mozAppearance') || Modernizr.testProp('appearance') ) {
            document.documentElement.classList.add('appearance');
        }
    },
    // ONLY ALLOW NUMBERS IN PHONE NUMBER
    onlyAllowNumbers: function (evt) {
        // Allow: backspace, delete, tab, escape, enter
        if ( $.inArray( evt.key ,["0" ,"1" ,"2" ,"3" ,"4" ,"5" ,"6" ,"7" ,"8" ,"9" ,"Backspace" ,"Delete" ,"Escape" ,"Enter" ,"ArrowRight" ,"ArrowLeft" ,"Tab"] ) === -1 ) {
            evt.preventDefault();
        } else {
            if(evt.key === "Enter"){
                console.log('hitting enter');
                if ( !$(copay.copaySubmitTextButton).hasClass('disabled') ) {
                    copay.validateCopayTextForm();
                }
            }
        }
    } ,
    // ADD SLASHES AS USER TYPES
    checkAndAddSlashes: function (evt) {

        const keyCodes = [8 ,37 ,38 ,39 ,40] ,
            str = evt.target.value;

        if ( $.inArray( evt.keyCode ,keyCodes ) === -1 ) {
            switch (str.length) {
                case 3:
                    $( evt.target ).val( str + "-" );
                    break;
                case 7:
                    $( evt.target ).val( str + "-" );
                    break;
                default:
                    break;
            }

        }
    } ,
    fakePlaceholder: function (evt) {
        var input = $(this);
        // alert("evt.type: " + evt.type + " placeholder: " + input.attr("placeholder") + " value:
        // " + input.val() );
        if ( evt.type === "focus" ) {
            // on enter, if value equals the placeholder, clear the value
            if ( input.val() == input.attr('placeholder') ) {
                input.val('');
            }
        }
        if ( evt.type === "blur" ) {
            // on exit, if value equals is empty, set the value back to the default
            if ( input.val() == '' || input.val() == input.attr('placeholder') ) {
                input.val(input.attr('placeholder'));
            }
        }
    },
    formSubmitEvent: function (evt) {
        /*
         * When the form submits
                 1. make sure the email value exists, via checking the length
                 2. check that the email is real
                 ==> validation status is preserved in the copay.emailIsValid variable
                 THEN fire the rest of the form validation
         */
        copay.formSubmitted = evt.target;
        var emailValue = copay.formSubmitted.querySelector("[name='email']").value;
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[ 0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if ( emailValue.length > 0 && emailValue.match(re) ) {
            // copay.isRealEmail(emailValue) - deprecated
            copay.good = 1;
            copay.emailIsValid = true;
            copay.formValidateEvent(copay.formSubmitted);
        } else {
            // console.warn("EMAIL ERROR: email field is empty");
            copay.emailIsValid = false;
            copay.formValidateEvent(copay.formSubmitted);
        }
        // console.log("END:", "formSubmitEvent", emailValue);
        evt.preventDefault();
    },
    formSubmitted: 0,
    emailIsValid: false,
    formErrors: 0,
    hasLaunchedCard: false,
    formValidateEvent: function (formEl) {
        /*
        * All users, on the third attempt, get through. This just iterates the error count, and once you are greater than 2, we make note of the email and send you on you way.
        */
        /*
        * cache elements
        */
        var $form = $(formEl),
            email = formEl.querySelector("[name='email']").value,
            canFormSubmit = true;

        $form.addClass("show-processing");

        /*
        * CLEAR ALL ERRORS
        */
        $form.removeClass("show-email-error");

        /*
         * #. If email or confirm email don't have a value
         */
        if ( email.length < 1 ) {
            // console.warn("EMAIL ERROR: an email input is empty");
            $form.addClass("show-email-error");
            canFormSubmit = false;
        }
        /*
         * #. If email is valid
         */
        if ( copay.emailIsValid === false ) {
            // console.warn("EMAIL ERROR: email is not a valid email");
            $form.addClass("show-email-error");
            canFormSubmit = false;
        }
        if ( canFormSubmit && copay.good === 1 ) {
            /*
             * FORM PASSED
             * ADD CLASS to show success
                   */

            $form.addClass("show-success");
            window.dataLayer.push({
                'event': 'savingsCard',
                'eventCategory': 'Form',
                'eventAction': 'Submit',
                'eventLabel': 'Get Savings Card-Email'
            });
            copay.formSubmitted.submit();
        } else {
            /*
             * FORM FAILED
             * 1. remove processing class to allow user to input data again
             */
            // console.warn("FORM FAILED");
            $form.removeClass("show-processing");
        }
        /*
         * RETURN TRUE OR FALSE to submit or not submit the form. 'canFormSubmit' is true unless it changes during validation, aka validation failed for one of the inputs
         */
        return canFormSubmit;
    },
    validateCopayTextForm: function validateCopayTextForm() {
        copay.textFormErrors = 0;
        if ( $('.phone-error.error') ) {
            $('.phone-error').removeClass('error');
        }
        var regEx = /^([2-9]{1})([0-9]{2})[\-\.\ ]?([0-9]{3})[-. ]?([0-9]{4})$/,
            phoneVal = $(copay.copayPhoneNumber).val(),
            clean = phoneVal.replace(/\D/g, '');

        validatePhone.hideCustomPhoneError();
        // If there have already been 2 errors, let this pass (having already verified it's a good
        // number via regex)
        if ( validatePhone.errorCount >= 2 && (phoneVal.match(regEx) && clean.length === 10) ) {
            copay.submitCopayTextForm();
            return;
        }

        var type = 'carrier';
        var json = {type: type, phone: clean};

        $.ajax({
            type: "POST",
            url: '/api/validatephone/',
            data: json,
            dataType: 'json'
        }).done(function (d) {
            var t = d.type;
            if ( t !== "mobile" && validatePhone.errorCount < 2 ) {
                if ( t === null ) {
                    copay.copayPhoneError.addClass('error');
                }
                this.phoneValid = false;
                validatePhone.showCustomPhoneError(t);
                validatePhone.errorCount++;
                copay.copayTextForm.addClass('show-error');
                copay.textFormErrors++;
                return false;
            } else if ( !phoneVal.match(regEx) || clean.length !== 10 ) {
                copay.throwError();
            } else {
                if ( phoneVal.match(regEx) && clean.length === 10 ) {
                    $(copay.copayTextForm).addClass('hide-copay-form');
                    $(copay.copaySubmitMsg).addClass('show-copay-msg');
                    $(copay.copayPhoneNumber).val(clean);
                    copay.submitCopayTextForm();
                }
                validatePhone.phoneValid = true;
                return true;
            }
        })
    },
    throwError: function () {
        copay.copayPhoneError.addClass('error');
        copay.copayTextForm.addClass('show-error');
        copay.textFormErrors++;
    },
    submitCopayTextForm: function submitCopayTextForm() {
        var formData = $(copay.copayTextForm).serialize();

        // SUBMIT FORM
        $.ajax({
            method: 'POST',
            url: '/api/savingscardtext/',
            data: formData,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        }).done(function ($data) {
            copay.copayTextAddToDataLayer();
            copay.textCopayFormSuccess();

        }).fail(function ($data) {
            console.log($data);
            console.log('FAILED');
        });
    },
    copayTextAddToDataLayer: function(){
        window.dataLayer.push({
            'event': 'savingsCard',
            'eventCategory': 'Form',
            'eventAction': 'Submit',
            'eventLabel': 'Get Savings Card-Text Message'
        });
    },
    textCopayFormSuccess: function() {
        $(copay.copaySubmitMsg).removeClass('show-copay-msg');

        $('[data-row="option2"]').addClass('text-successful');
        var header = $('[data-row="option2"]').find('.header-row')[0];
        $('html, body').animate({
            scrollTop: $(header).offset().top - 25
        }, 1000);
    }
};
